import styled from 'styled-components';
import { Row } from '../Grid';

export const SStepWrapper = styled(Row)`
  .button {
    max-width: 200px;
    width: 100%;
  }
`;
